import { PatientDetailUtils } from '../../../../utils/PatientDetail.utils';
import type { FragmentType } from '@orthly/graphql-inline-react';
import { getFragmentData, graphql } from '@orthly/graphql-inline-react';
import type { FlossColor } from '@orthly/ui-primitives';
import { FlossPalette, Icon, styled, Text } from '@orthly/ui-primitives';
import React from 'react';

const PillContentContainer = styled('div', {
    shouldForwardProp: p => p !== 'backgroundColor',
})<{ backgroundColor: FlossColor }>(({ backgroundColor }) => ({
    backgroundColor: FlossPalette[backgroundColor],
    padding: '2px 4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
}));

const StyledIcon = styled(Icon)({
    color: FlossPalette.WHITE,
    fontSize: '18px',
});

const PatientScanPillContentScan_Fragment = graphql(`
    fragment PatientScanPillContentScan_Fragment on PatientScan {
        pill_content {
            title
            icon
            variant
        }
    }
`);

interface PatientScanPillContentProps {
    scanFragment: FragmentType<typeof PatientScanPillContentScan_Fragment>;
}

export const PatientScanPillContent: React.VFC<PatientScanPillContentProps> = ({ scanFragment }) => {
    const scan = getFragmentData(PatientScanPillContentScan_Fragment, scanFragment);

    const { icon, backgroundColor } = PatientDetailUtils.getPatientScanPillContentConfig(scan.pill_content);

    return (
        <PillContentContainer backgroundColor={backgroundColor}>
            <StyledIcon icon={icon} />
            <Text variant={'caption'} medium color={'WHITE'} style={{ padding: 0 }}>
                {scan.pill_content.title}
            </Text>
        </PillContentContainer>
    );
};
